import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {BiHelpCircle} from "react-icons/bi";
import {CatholicHouseholdActionTypes} from "../../../AppLocals/CatholicHousehold/consts/CatholicHouseholdActionTypes";
import {createDataImporter} from "../../../AppLocals/factory/createDataImporter";
import {catholicHousehold_doImportFile_Api} from "../../../../apis/catholicHousehold";
import {bindQueryParams} from "../../../AppLocals/functions/routerHelper";
import TooltipApp from "../../../../components/TooltipApp";

const template_url =
    'https://docs.google.com/spreadsheets/d/1rViiCySjNH_mKlaa7H1TFi9MKYiKlXuRAjbB1-ksCD0/edit?usp=sharing'


const descriptions = [
    // SHEET I
    {
        sheet: 'catholic household',
        label: 'information catholic household',
    },
    {
        column: 'A',
        name: 'DOCUMENT_NO',
        primary: true,
        label: 'catholic family record number',
        optional: false,
        noted: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span>{t('catholic family record number description')}</span>
                                <span className="font-medium text-primary-500">
                                    {`( ${t('required field')} )`}
                                </span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'B',
        name: 'TITLE',
        label: 'title household',
        optional: false,
    },
    {
        column: 'C',
        name: 'PARISH',
        label: 'belong to parish',
        optional: false,
    },
    {
        column: 'D',
        name: 'DIOCESE',
        label: 'belong to the diocese',
        optional: false,
    },
    {
        column: 'E',
        name: 'START_DATE',
        label: "date of immigration",
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span className="font-semibold text-secondary">
                                    {`${t('re-format')} : DD/MM/YYYY`}
                                </span>
                                <span>{`( ${t('optional')} )`}</span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'F',
        name: 'CONTACT_NAME',
        label: 'contact name',
        optional: false,
    },
    {
        column: 'G',
        name: 'CONTACT_ADDRESS',
        label: 'address',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span className="font-semibold text-secondary">
                                    {t('ex: address')}
                                </span>
                                <span>{`( ${t('optional')} )`}</span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'H',
        name: 'CONTACT_PHONE',
        label: 'contact phone',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span className="font-semibold text-secondary">
                                    {t('ex: phone')}
                                </span>
                                <span>{`( ${t('optional')} )`}</span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'I',
        name: 'CONTACT_EMAIL',
        label: 'contact email',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span className="font-semibold text-secondary">
                                    {t('ex: email')}
                                </span>
                                <span>{`( ${t('optional')} )`}</span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    // SHEET II
    {
        sheet: 'member',
        label: 'member information',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={t('member information description')}>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'A',
        name: 'DOCUMENT_NO',
        primary: true,
        label: 'catholic family record number',
        optional: false,
        noted: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span>{t('catholic family record number description')}</span>
                                <span className="font-medium text-primary-500">
                                    {`( ${t('required field')} )`}
                                </span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'B',
        name: 'PATRON_SAINT_NAME',
        label: 'holy name',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span className="font-semibold text-secondary">
                                    {t('patron saint description')}
                                </span>
                                <span>{`( ${t('optional')} )`}</span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'C',
        name: 'FULLNAME',
        label: 'full name',
        optional: false,
    },
    {
        column: 'D',
        name: 'DATE_OF_BIRTH',
        label: 'date of birth',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <span className="font-semibold text-secondary text-xs italic">
                                {`${t('re-format')} : DD/MM/YYYY`}
                            </span>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'E',
        name: 'PLACE_OF_BIRTH',
        label: 'place of birth',
        optional: false,
    },
    {
        column: 'F',
        name: 'DATE_OF_DEATH',
        label: 'date of death',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div className="space-x-1 text-xs italic">
                                <span className="font-semibold text-secondary">
                                    {`${t('re-format')} : DD/MM/YYYY`}
                                </span>
                                <span>{`( ${t('optional')} )`}</span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'G',
        name: 'RELATIONSHIP_TYPE',
        label: 'role in the household',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={`${t('note')} : ${t('father')}, ${t('mother')}, ${t('children')}`}>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'H',
        name: 'GENDER',
        label: 'gender',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={`${t('note')} : ${t('male')}, ${t('female')}`}>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'I',
        name: 'FATHER_NAME',
        label: 'father name',
        optional: false,
    },
    {
        column: 'J',
        name: 'MOTHER_NAME',
        label: 'mother name',
        optional: false,
    },

    {
        column: 'K -> Q',
        label: 'sacrament of baptism',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={`${t('sacrament of info description')}`}>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'K',
        name: 'BAPTISM_DATE',
        label: 'day of baptism',
        optional: true,
    },
    {
        column: 'L',
        name: 'BAPTISM_NO',
        label: 'baptism book no',
        optional: true,
    },
    {
        column: 'M',
        name: 'BAPTISM_CHURCH_NAME',
        label: 'church',
        optional: true,
    },
    {
        column: 'N',
        name: 'BAPTISM_PARISH_NAME',
        label: 'parish',
        optional: true,
    },
    {
        column: 'O',
        name: 'BAPTISM_DIOCESE_NAME',
        label: 'diocese',
        optional: true,
    },
    {
        column: 'P',
        name: 'BAPTISM_OFFICIANT_NAME',
        label: 'celebrant',
        optional: true,
    },
    {
        column: 'Q',
        name: 'BAPTISM_PARTICIPANT_NAME',
        label: 'godparent',
        optional: true,
    },
    {
        column: 'R -> X',
        name: 'FIRST COMMUNION',
        label: 'first communion',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={
                            `${t('sacrament of info description')}. ${t('includes the columns')} : 
                            FIRST_COMMUNION_DATE,
                            FIRST_COMMUNION_NO, 
                            FIRST_COMMUNION_CHURCH_NAME,
                            FIRST_COMMUNION_PARISH_NAME, 
                            FIRST_COMMUNION_DIOCESE_NAME, 
                            FIRST_COMMUNION_OFFICIANT_NAME, 
                            FIRST_COMMUNION_PARTICIPANT_NAME`
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'Y -> AE',
        name: 'CONFIRMATION',
        label: 'sacrament of confirmation',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={
                            `${t('sacrament of info description')}. ${t('includes the columns')} : 
                            CONFIRMATION_DATE,
                            CONFIRMATION_NO, 
                            CONFIRMATION_CHURCH_NAME,
                            CONFIRMATION_PARISH_NAME, 
                            CONFIRMATION_DIOCESE_NAME, 
                            CONFIRMATION_OFFICIANT_NAME, 
                            CONFIRMATION_PARTICIPANT_NAME`
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'AF -> AL',
        name: 'MATRIMONY',
        label: 'sacrament of matrimony',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={
                            `${t('sacrament of info description')}. ${t('includes the columns')} : 
                            MATRIMONY_DATE,
                            MATRIMONY_NO, 
                            MATRIMONY_CHURCH_NAME,
                            MATRIMONY_PARISH_NAME, 
                            MATRIMONY_DIOCESE_NAME, 
                            MATRIMONY_OFFICIANT_NAME, 
                            MATRIMONY_PARTICIPANT_NAME`
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'AM -> AP',
        name: 'HOLY ORDERS',
        label: 'sacrament of holy orders',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        classNames={{ root: "text-xs italic" }}
                        title={
                            `${t('sacrament of info description')}. ${t('includes the columns')} : 
                            HOLY_ORDERS_DATE,
                            HOLY_ORDERS_CHURCH_NAME,
                            HOLY_ORDERS_PARISH_NAME, 
                            HOLY_ORDERS_DIOCESE_NAME,`
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
]


export const CatholicHouseholdImporter = ({
                                              import_type,
                                              type, id,
                                              owner,
                                              onCancel,
                                          }) => {
    const query = bindQueryParams([
        {
            type: type,
        }, {
            id: id,
        }
    ]);

    const apiInfo = catholicHousehold_doImportFile_Api
    if (_.isEmpty(id)) {
        return null
    }
    switch (import_type) {
        case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_IMPORT:
            return createDataImporter(
                'catholic household',
                owner,
                template_url,
                descriptions,
                query,
                apiInfo,
                {}
            );

        default:
            return null
    }
}
